/* Euronavigate footer: BUCKS display currency, preserve Shopify region/language separately. */
(() => {
  const country = {
    AZN:['Azərbaycan','az'],TRY:['Türkiye','tr'],USD:['US Dollar','us'],
    EUR:['Euro','eu'],GBP:['British Pound','gb'],CAD:['Canadian Dollar','ca'],
    JPY:['Japanese Yen','jp'],AUD:['Australian Dollar','au'],CHF:['Swiss Franc','ch'],
    SEK:['Swedish Krona','se'],NOK:['Norwegian Krone','no'],DKK:['Danish Krone','dk'],
    PLN:['Polish Złoty','pl'],AED:['UAE Dirham','ae'],SAR:['Saudi Riyal','sa'],
    CNY:['Chinese Yuan','cn'],INR:['Indian Rupee','in'],RUB:['Russian Ruble','ru'],
    BRL:['Brazilian Real','br'],MXN:['Mexican Peso','mx'],NZD:['New Zealand Dollar','nz'],
    KRW:['South Korean Won','kr'],ZAR:['South African Rand','za']
  };
  const flagUrl = code => 'https://cdn.shopify.com/static/images/flags/'+(country[code]?.[1]||'us')+'.svg?width=56';
  let latest = '';
  let lastList = '';
  let scheduled=false;
  function setCurrency(root, code) {
    if (!code || !/^[A-Z]{3}$/.test(code)) return;
    const details=country[code];
    const label=details?details[0]+' ('+code+')':code;
    const el=root.querySelector('.en-footer-currency-value');
    const img=root.querySelector('.en-footer-currency-flag');
    if(el && el.textContent!==label) el.textContent=label;
    if(img && details && img.dataset.code!==code) {
      img.src=flagUrl(code);
      img.alt=details[0];
      img.dataset.code=code;
    }
  }
  function sync() {
    scheduled=false;
    const root=document.querySelector('.en-footer-localization');
    const widget=document.querySelector('.buckscc-currency-wrapper');
    if(!root||!widget||!document.documentElement.classList.contains('en-bucks-ready'))return;
    const code=widget.querySelector('.bucks-selected')?.textContent?.trim();
    if(!code)return;
    if(latest!==code) {latest=code;setCurrency(root,code);}
    const list=root.querySelector('.en-footer-currency-options');
    const items=[...widget.querySelectorAll('.buckscc-select-options li[rel]')];
    const signature=items.map(item=>item.getAttribute('rel')+'|'+item.textContent.trim()).join(';');
    if(list && items.length && signature!==lastList) {
      lastList=signature;
      list.replaceChildren();
      for(const item of items) {
        const opt=item.getAttribute('rel');
        if(!/^[A-Z]{3}$/.test(opt||''))continue;
        const btn=document.createElement('button');
        btn.type='button';
        btn.dataset.currency=opt;
        btn.setAttribute('role','option');
        btn.setAttribute('aria-selected',String(opt===code));
        const title=item.textContent.trim();
        const details=country[opt];
        if(details) {
          const img=document.createElement('img');
          img.src=flagUrl(opt);
          img.alt='';
          btn.appendChild(img);
        }
        const span=document.createElement('span');
        span.textContent=title;
        btn.appendChild(span);
        list.appendChild(btn);
      }
    }
    if(list)list.querySelectorAll('button[data-currency]').forEach(btn=>
      btn.setAttribute('aria-selected',String(btn.dataset.currency===code)));
  }
  const tick=()=>{
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(sync);
  };
  function init() {
    const root=document.querySelector('.en-footer-localization');
    if(!root||root.dataset.enFooterWired)return;
    root.dataset.enFooterWired='1';
    const trigger=root.querySelector('.en-footer-currency-trigger');
    const list=root.querySelector('.en-footer-currency-options');
    const region=root.querySelector('.en-footer-region-toggle');
    const native=root.querySelector('.en-footer-native');
    trigger?.addEventListener('click',()=>{
      const open=list.hasAttribute('hidden');
      if(open)list.removeAttribute('hidden');else list.setAttribute('hidden','');
      trigger.setAttribute('aria-expanded',String(open));
    });
    list?.addEventListener('click',event=>{
      const btn=event.target.closest('button[data-currency]');
      if(!btn)return;
      const option=[...document.querySelectorAll('.buckscc-currency-wrapper .buckscc-select-options li')]
        .find(el=>el.getAttribute('rel')===btn.dataset.currency);
      if(option)option.click();
      list.setAttribute('hidden','');
      trigger?.setAttribute('aria-expanded','false');
      setTimeout(tick,150);
      setTimeout(tick,850);
    });
    region?.addEventListener('click',()=>{
      const open=native.hasAttribute('hidden');
      if(open)native.removeAttribute('hidden');else native.setAttribute('hidden','');
      region.setAttribute('aria-expanded',String(open));
    });
    document.addEventListener('click',event=>{
      if(!root.contains(event.target) && !list.hasAttribute('hidden')) {
        list.setAttribute('hidden','');
        trigger?.setAttribute('aria-expanded','false');
      }
    });
    document.addEventListener('keydown',event=>{
      if(event.key==='Escape') {
        list.setAttribute('hidden','');
        trigger?.setAttribute('aria-expanded','false');
      }
    });
    new MutationObserver(tick).observe(document.body,{
      subtree:true,childList:true,characterData:true,
      attributes:true,attributeFilter:['bucks-currency','rel','bucks-current']
    });
    tick();
  }
  if(document.readyState==='loading')
    document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();